const getters = {  
    userInfo: state => state.user.userInfo,
    token: state => state.user.token,
    userName: state => state.user.userName,
    mobile: state => state.user.mobile,
    isSidebarShow: state => state.ability.isSidebarShow,
    setCliQueryParam: state => state.ability.setCliQueryParam,
}
export default getters